
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rollers/for-windows/[slug]",
      function () {
        return require("private-next-pages/rollers/for-windows/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rollers/for-windows/[slug]"])
      });
    }
  